/** Legacy DTO — accounting app does not enforce module permissions. */
export interface AccessRightDto {
  appModuleName: string;
  moduleId?: string;
  moduleName?: string;
  canView: boolean;
  canAdd: boolean;
  canEdit: boolean;
  canDelete: boolean;
  canExport?: boolean;
}

export interface LoginCompanyDto {
  companyId: string;
  companyName: string;
}

export interface LoginRequest {
  userName: string;
  password: string;
}

/** Matches AccountingBackend LoginResponse (camelCase JSON). */
export interface LoginResponse {
  userId: string;
  userName: string;
  name: string;
  emailId: string;
  mobileNo: string;
  userType: number;
  token: string;
  refreshToken: string;
  accessTokenExpiresAtUtc?: string;
  refreshTokenExpiresAtUtc: string;
  companies: LoginCompanyDto[];
}

export interface RefreshTokenRequest {
  refreshToken: string;
}

export interface SelectCompanyRequest {
  companyId: string;
}

export interface SelectCompanyResponse {
  companyId: string;
  companyName: string;
  mailingName?: string | null;
  isActive: boolean;
}

export interface AuthUserSnapshot {
  userId: string;
  userName: string;
  name: string;
  emailId: string;
  mobileNo: string;
  userType: number;
  /** @deprecated Legacy sessions — prefer userType. */
  userRole?: string;
}

export interface AuthStoragePayload {
  token: string;
  refreshToken?: string;
  refreshTokenExpiresAt?: string;
  accessTokenExpiresAtUtc?: string;
  companies?: LoginCompanyDto[];
  user: AuthUserSnapshot;
}

export const AUTH_STORAGE_KEY = 'accounting_auth';
